import React, { FC, ReactNode } from 'react'
import { ButtonSize } from './interfaces/size'
import { RedirectButtonProps } from './interfaces/redirectButtonProps'

const RedirectButton: FC<RedirectButtonProps> = ({children, color, path, size, textColor}) => {

    if (!children || children === null) throw new Error(`children are missing`)

    if (!path || path === null) throw new Error(`path is missing`)

    const getColorClasses = (color: string): string => {
        if (!color || color === null) throw new Error(`Color is missing`)

        const colorMap: Record<string, string> = {
        blue: 'bg-blue-600 hover:bg-blue-700',
        red: 'bg-red-600 hover:bg-red-700',
        green: 'bg-green-600 hover:bg-green-700',
        purple: 'bg-purple-600 hover:bg-purple-700',
        gray: 'bg-gray-600 hover:bg-gray-700',
        }
        return colorMap[color] || 'bg-blue-600 hover:bg-blue-700'
    }

    const getTextColorClasses = (textColor?: string): string => {
        if (!textColor) return 'text-white'
        
        const textColorMap: Record<string, string> = {
            white: 'text-white',
            black: 'text-black',
            blue: 'text-blue-600',
            red: 'text-red-600',
            green: 'text-green-600',
            purple: 'text-purple-600',
            gray: 'text-gray-600',
            yellow: 'text-yellow-600'
        }
        return textColorMap[textColor] || 'text-white'
    }

    const getSizeClasses = (size: ButtonSize): string => {
        const sizeMap: Record<ButtonSize, string> = {
            [ButtonSize.XSmall]: 'px-2 py-1 text-xs',
            [ButtonSize.Small]: 'px-3 py-1.5 text-sm',
            [ButtonSize.Medium]: 'px-4 py-2 text-base',
            [ButtonSize.Large]: 'px-6 py-3 text-lg',
            [ButtonSize.XLarge]: 'px-8 py-4 text-xl',
            [ButtonSize.XXLarge]: 'px-10 py-5 text-2xl'
        }
        return sizeMap[size] || sizeMap[ButtonSize.Medium]
    }

  return (
    <button onClick={(e) => {window.location.href=`${path}`}} className={`${getColorClasses(color)} ${getSizeClasses(size)} ${getTextColorClasses(textColor)} rounded-lg transition-colors`}>
        {children}
    </button>
  )
}

export default RedirectButton